module.exports = __webpack_public_path__ + "img/light-switch-on-lg.0da2eba3.svg";